<template>
	<div class="sortlist">
		<el-card v-if="isload">
			<el-row>
				<el-col :span="16">
					<span style="color:transparent">占位</span>
				</el-col>
				<el-col :span="3" class="rightcol">
					<!-- <span>语言类型：</span> -->
					<span>{{selectsort_lang.languagetype}}：</span>
				</el-col>
				<el-col :span="5" class="rightcol">
					<el-select size="small" v-model="lang" :clearable="true" style="200px" @change="getTablelist('0')">
						<el-option v-for="(item,index) in langlist" :key="index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-col>
			</el-row>
			<el-row style="height:10px;"></el-row>
			<el-row>
				<el-col :span="24">
					<el-table
						:data="tableData"
						style="width: 100%"
						:row-key="row => { return row.p_no+'★'+row.lang }"
						border
						lazy
						:height="height"
						:load="loadChild"
						:excess-rows="5"
						:stripe="stripe"
						:highlight-current-row="false"
						inverse-current-row
						header-align="center"
						use-virtual
						:row-height="48"
						:tree-props="{ children: 'children', hasChildren: 'haschild' }"
						:header-cell-style="{ background: '#f5f5f5', color: '#606266', textAlign: 'center', paddingTop: '8px', paddingBottom: '8px' }"
						:cell-style="{ padding: '0px', height: '40px' }"
					>
						<el-table-column prop="p_sort" :label="selectsort_lang.sortname"></el-table-column>
						<el-table-column prop="p_no" :label="selectsort_lang.sortno"></el-table-column>
						<el-table-column prop="langtype" :label="selectsort_lang.languagetype"></el-table-column>
						<el-table-column width="180" :label="selectsort_lang.ischecked">
							<template slot-scope="scope">
								<el-switch
									v-model="scope.row.isselected"
									:active-value="true"
									:inactive-value="false"
									active-color="#13ce66"
									@change="val => changeselected(val, scope.row)"
								></el-switch>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
<!-- 			<div>
				<el-row>
					<el-col :span="12">
						<span>{{$lang.label.public.total}} {{ count }} {{$lang.label.public.rows}}
						{{$lang.label.public.orders}}</span>
					</el-col>
				</el-row>
			</div> -->
			
		</el-card>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		},
		isdialog: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			tableData: [],
			height: (window.innerHeight * 68) / 100,
			load: false,
			stripe: true,
			count: 0,
			divclass: 'sortlist',
			lang:'',
			langlist:[],
			divclass:'sortlist',
			mode:'商品分类',
			selectsort_lang:{},
			selectedjson:'',
			isload:false
		};
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/baseinfo/baselist.scss');
		debugger
		if(this.isdialog){
			this.height=(window.innerHeight *50) / 100;
		}
		if(this.urlparam.searchjson!=undefined){
			if(this.urlparam.searchjson!='')
				this.selectedjson=JSON.parse(this.urlparam.searchjson);
		}
		this.loadlanguage();
	},
	methods: {
		init(e){
			if(e.searchjson!=undefined)
			{
				if(e.searchjson!='')
				  this.selectedjson=JSON.parse(e.searchjson);
			}	
			this.loadlanguage();	
		},
		loadlanguage(){
			var that=this;
			debugger
			this.$public.GetLanguageByMode('selectsort',this).then(res=>{
				if(res.state=='1')
				{
					that.isload=true;
					that.selectsort_lang=that.$lang.label.selectsort;
					this.getTablelist('0');
				}
			});
			this.GetLanglist();
		},
		GetLanglist(){
			//debugger
			var that = this;
			this.$apipost.get.dic({ type: '语言类型' }).then(res => {
				//console.log('list',res.list);
				if (res.list != undefined) {
					that.langlist=res.list;
				}
			});
		},
		refreshgrid(){
			this.getTablelist('0');
		},
		getTablelist(pid,lang, resolve) {
			if(lang==undefined)
				lang=this.lang;
			var that = this;
			var paraminfo={
				p_p_no: pid,
				lang:lang,
				isenabled:'',
				isshowpic:0
			}
			//debugger
			this.$apipost.get.GetCargoSortList({paraminfo:paraminfo}).then(res => {
				if (res.list != undefined) {
					if (pid == '') that.count = res.list.length;
					var list=res.list;
					list.forEach(e=>{
						e.isselected=false;
						if(that.selectedjson!=""){
							that.selectedjson.forEach(b=>{
								if(b.p_no==e.p_no)
									e.isselected=true;
							});
						}
					});
					if (resolve == undefined) {
						that.tableData =list;
					}
					else resolve(list);
				}else{
					if(pid==''){
						that.count=0;
						if (resolve == undefined) {
							that.tableData = [];
						}
						else resolve([]);
					}
					else resolve([]);
				}
			});
		},
		reloadpage(){
			this.GetTabData({index:this.activeTabIndex});
		},
		//加载子分类
		loadChild(tree, treeNode, resolve) {
			this.getTablelist(tree.p_no,tree.lang,resolve);
		},
		//选中使用
		changeselected(val, row) {
			var param={
				param:this.urlparam,
				p_no: row.p_no,
				lang:row.lang,
				type:val,
				p_sort:row.p_sort
			}
			this.$emit('checkedsortfun',param);
		},
	}
};
</script>

<style></style>
